const useLocalStorage = <Type>(
  key: string
): [(value: Type) => void, () => Type | null, () => void] => {
  const storeValue = (value: Type) =>
    localStorage.setItem(key, JSON.stringify(value));

  const retrieveValue = (): Type | null => {
    const jsonValue = localStorage.getItem(key);

    if (jsonValue) {
      return JSON.parse(jsonValue);
    } else {
      return null;
    }
  };

  const removeValue = (): void => localStorage.removeItem(key);

  return [storeValue, retrieveValue, removeValue];
};

export default useLocalStorage;
